<div>
  <h2>DESIGN-SYSTEM</h2>
  <p>
    Le projet design-system a pour but de référencer les classes .scss et composants existants mis à disposition dans vitam-ui par le biais
    d'exemples d'utilisation.
  </p>

  <h3>Inspecter</h3>
  <p>Inspecter le DOM pour voir les classes .scss et/ou composants utilisées.</p>
</div>
